import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import localeEs from '@angular/common/locales/es';
import { ApplicationConfig, LOCALE_ID } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { httpRequestInterceptor } from './core/interceptor/http-request.interceptor';
import { ValidationsServiceBase } from './pages/hiring/services/validations/validations.base';

import { ValidationsProxyService } from './pages/hiring/services/validations/validations.proxy.service';
import { PaymentRequirementService, PaymentRequirementServiceBase } from './core/services/payments/payment-requirement.service';

registerLocaleData(localeEs);

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptors([httpRequestInterceptor])),
    {
      provide: LOCALE_ID,
      useValue: 'es-MX',
    },
    {
      provide: 'googleTagManagerId',
      useValue: 'GTM-53H4JZPX',
    },
    {
      provide: ValidationsServiceBase,
      useClass: ValidationsProxyService,
    },
    {
      provide: PaymentRequirementServiceBase,
      useClass: PaymentRequirementService,
    },
  ],
};
